/* Divarouj Language Switcher Fix — additive, self-contained.

   Root cause (two parts):

   1) snippets/languages.liquid renders a `[data-dropdown-open]` button next
      to a `[data-dropdown-wrapper]` list of `[data-locale-item]` buttons
      (one per shop.published_locales entry — en/ar). Clicking the opener
      did nothing: no listener anywhere in the theme toggled it open. The
      base T4S theme already ships the CSS this component needs — a
      `.t4s-dropdown__wrapper.is--opened` rule drives opacity/visibility/
      transform/pointer-events via a transition — but nothing in this
      theme's own JS ever added or removed that `is--opened` class for the
      language switcher instance, so the panel stayed permanently hidden.

   2) Even with the panel visible, there was no way to actually change the
      active locale: clicking an item never called Shopify's localization
      endpoint. snippets/languages.liquid now renders a real
      `{% form 'localization' %}` (with a `language_code` hidden input,
      marked `[data-locale-form-input]`) inside each `[data-locale-wrap]`.
      Using Shopify's own generated form guarantees the correct action URL
      and any required hidden fields — this script only fills in the
      chosen locale and submits that form, rather than guessing the
      request shape itself.

   Scoped strictly to elements inside `[data-locale-wrap]`, so it cannot
   interfere with any other dropdown/menu behaviour handled elsewhere in
   the theme or by the base theme's global.min.js. It follows the same
   "small, targeted, additive fix" convention already established by the
   "Diva Cart Guard" script in layout/theme.liquid for working around
   base-theme JS gaps without having to modify or fully reverse-engineer
   the minified base theme. */
(function () {
  'use strict';

  var OPEN_CLASS = 'is--opened';

  function getWrapper(openerBtn) {
    var container = openerBtn.closest('[data-locale-wrap]');
    return container ? container.querySelector('[data-dropdown-wrapper]') : null;
  }

  function closeWrapper(wrapper, opener) {
    if (!wrapper) return;
    wrapper.classList.remove(OPEN_CLASS);
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }

  function closeAllExcept(exceptWrapper) {
    var all = document.querySelectorAll('[data-locale-wrap] [data-dropdown-wrapper]');
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== exceptWrapper) closeWrapper(all[i], all[i].parentNode ? all[i].parentNode.querySelector('[data-dropdown-open]') : null);
    }
  }

  function openWrapper(wrapper, opener) {
    if (!wrapper) return;
    closeAllExcept(wrapper);
    wrapper.classList.add(OPEN_CLASS);
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function switchLocale(item, localeCode) {
    var wrap = item.closest('[data-locale-wrap]');
    if (!wrap) return;
    var form = wrap.querySelector('form');
    var input = wrap.querySelector('[data-locale-form-input]');
    if (form && input) {
      input.value = localeCode;
      form.submit();
    }
  }

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest ? evt.target.closest('[data-locale-wrap] [data-dropdown-open]') : null;
    if (opener) {
      evt.preventDefault();
      var wrapper = getWrapper(opener);
      if (!wrapper) return;
      var isOpen = wrapper.classList.contains(OPEN_CLASS);
      if (isOpen) { closeWrapper(wrapper, opener); }
      else { openWrapper(wrapper, opener); }
      return;
    }

    var item = evt.target.closest ? evt.target.closest('[data-locale-wrap] [data-locale-item]') : null;
    if (item) {
      evt.preventDefault();
      var iso = item.getAttribute('data-iso');
      if (iso) { switchLocale(item, iso); }
      return;
    }

    if (!evt.target.closest || !evt.target.closest('[data-locale-wrap]')) {
      closeAllExcept(null);
    }
  }, false);

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) closeAllExcept(null);
  });
})();
